import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { i18n } from '@/i18n';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteBusinessModal',
  props: {
    modalState: { type: Boolean }
  },
  emits: ["close", "remove"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

//変数
const t = i18n.t;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.modalState,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('削除ボタンテキスト'),
    onOnBack: _cache[0] || (_cache[0] = ($event: any) => (emits('close'))),
    onOnNext: _cache[1] || (_cache[1] = ($event: any) => (emits('remove')))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('選択した取引を削除')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('取引削除モーダルテキスト1')), 1),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_unref(t)('取引削除モーダルテキスト2')), 1)
    ]),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label"]))
}
}

})